import { templates } from './MessageTemplates';

const STRING_TEMPLATES = templates;

function formatStringToCurrency(amount) {
  return Number(amount.replace(/,/g, '')).toLocaleString({
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

class Message {
  constructor(recipient, template, str) {
    this.recipient = recipient;
    this.template = template;
    this.str = str;
  }
}

class SikapMessage extends Message {
  getMessage() {
    return this.setMessage(this.recipient);
  }

  setMessage(recipient) {
    this.str = this.str.replace(
      '[AMOUNT]',
      formatStringToCurrency(recipient.amount)
    );
    this.str = this.str.replace(
      '[SEMESTER]-[ACADEMIC_YEAR]',
      recipient.semester + '-' + recipient.academic_year
    );
    return this.str;
  }
}

class TesMessage extends Message {
  getMessage() {
    return this.setMessage(this.recipient);
  }

  setMessage(recipient) {
    this.str = this.str.replace(
      '[AMOUNT]',
      formatStringToCurrency(recipient.amount)
    );
    this.str = this.str.replace(
      '[SEMESTER]-[ACADEMIC_YEAR]',
      recipient.semester + ' ' + recipient.academic_year
    );
    return this.str;
  }
}

class TesIndividualMessage extends Message {
  getMessage() {
    return this.setMessage(this.recipient);
  }

  setMessage(recipient) {
    this.str = this.str.replace(
      '[AMOUNT]',
      formatStringToCurrency(recipient.amount)
    );
    this.str = this.str.replace(
      '[SEMESTER]-[ACADEMIC_YEAR]',
      recipient.semester + ' ' + recipient.academic_year
    );
    return this.str;
  }
}

class TesTdpMessage extends Message {
  getMessage() {
    return this.setMessage(this.recipient);
  }

  setMessage(recipient) {
    this.str = this.str.replace(
      '[AMOUNT]',
      formatStringToCurrency(recipient.amount)
    );
    this.str = this.str.replace(
      '[SEMESTER]-[ACADEMIC_YEAR]',
      recipient.semester + ' - ' + recipient.academic_year
    );
    return this.str;
  }
}

class CspMessage extends Message {
  getMessage() {
    return this.setMessage(this.recipient);
  }

  setMessage(recipient) {
    this.str = this.str.replace(
      '[AMOUNT]',
      formatStringToCurrency(recipient.amount)
    );
    this.str = this.str.replace(
      '[SEMESTER]-[ACADEMIC_YEAR]',
      recipient.semester + ' ' + recipient.academic_year
    );
    return this.str;
  }
}

class ReimbursementMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class SalaryMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class BenefitsMonetizationMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class BenefitsClothingAllowanceMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class BenefitsYearEndBonusMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class BenefitsLoadAllowanceMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class RqatDepositedMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class RqatCheckPickupMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class LoyaltyAwardMessage extends Message {
  getMessage() {
    return this.str;
  }
}

class SalaryBonusDifferentialMessage extends Message {
  getMessage() {
    return this.str;
  }
}

function getTemplateMessage(template, customTemplateMessage) {
  if (customTemplateMessage) {
    return customTemplateMessage;
  }

  const temp = STRING_TEMPLATES.find((t) => t.name === template);
  return temp ? temp.message : '';
}

export default function setMessage(template, recipient, customTemplateMessage) {
  const messageClasses = {
    BENEFITS_MONETIZATION: BenefitsMonetizationMessage,
    BENEFITS_CLOTHING_ALLOWANCE: BenefitsClothingAllowanceMessage,
    BENEFITS_YEAR_END_BONUS: BenefitsYearEndBonusMessage,
    BENEFITS_LOAD_ALLOWANCE: BenefitsLoadAllowanceMessage,
    CSP: CspMessage,
    TES: TesMessage,
    TES_INDIVIDUAL: TesIndividualMessage,
    TES_TDP: TesTdpMessage,
    SALARY_REG: SalaryMessage,
    SALARY_COS: SalaryMessage,
    SIKAP: SikapMessage,
    REIMBURSEMENT: ReimbursementMessage,
    RQAT_DEPOSITED: RqatDepositedMessage,
    RQAT_CHECK_PICK_UP: RqatCheckPickupMessage,
    LOYALTY_AWARD: LoyaltyAwardMessage,
    SALARY_BONUS_DIFFERENTIAL: SalaryBonusDifferentialMessage,
  };

  const MessageClass = messageClasses[template];

  if (MessageClass) {
    const message = new MessageClass(
      recipient,
      template,
      getTemplateMessage(template, customTemplateMessage)
    );
    return message.getMessage();
  }
}
